<template>
    <div class="panel-body">
        <div v-for="group in channel.items" :key="group.groupingName">
            <div class="row">
                <div class="col-md-12 clearfix">
                    <h3>{{group.groupingName}}</h3>
                </div>
            </div>
            <input-loader :fields="group.groupItems"></input-loader>
        </div>

        <div class="form-group row">
            <div class="col-md-9 ml-auto text-right">
                <button v-on:click="saveWynshop()" type="button" class="btn btn-primary">Save</button>
                <a :href="baseUrl+ '/channels'" class="btn btn-secondary">
                    Cancel
                </a>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host;
    import InputLoader from "../form/form-loader.vue";
    import getNestedProperty from "../../mixins/getNestedProperty.js";

    export default {
        name: "wynshop-specific",
        components: {
            "input-loader": InputLoader,
        },
        mixins: [getNestedProperty],
        props: ['channelvalues', 'channeloptions'],
        data() {
            return {
                channel: {
                    items: [],
                },
                alert: {
                    message: "",
                    status: "alert-success",
                    timeOut: 15000,
                },
                baseUrl: base_url,
                canSeeAdminFields: dataObject.canSeeAdminFields,
                postURL: base_url + "/channels/" + dataObject.channel.id,
                loading: false
            };
        },
        methods: {
            saveWynshop: function () {
                this.loading = true;
                this.$emit("channel-specific-save", this.channel);
            },
            setItems: function () {
                var cvs = this.channelvalues;
                var cfo = this.channeloptions;
                this.channel.items = [
                    {
                        groupingName : "Store Details",
                        groupItems : [
                            {
                                name : "store_id",
                                label : "Store ID",
                                required : false,
                                type : "text",
                                disabled : true,
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'store_id')) ? cvs.json_options.configuration.store_id  : "",
                            },
                            {
                                name : "store_name",
                                label : "Store Name",
                                required : false,
                                type : "text",
                                disabled : true,
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'store_name')) ? cvs.json_options.configuration.store_name  : "",
                            },
                            {
                                name : "store_status",
                                label : "Store Status",
                                required : false,
                                type : "text",
                                disabled : true,
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'store_status')) ? cvs.json_options.configuration.store_status  : "",
                            },
                            {
                                name : "store_type",
                                label : "Store Type",
                                required : false,
                                type : "text",
                                disabled : true,
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'store_type')) ? cvs.json_options.configuration.store_type  : "",
                            },
                            {
                                name : "site_name",
                                label : "Site Name",
                                required : false,
                                type : "text",
                                disabled : true,
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'site_name')) ? cvs.json_options.configuration.site_name  : "",
                            },
                            {
                                name : "retailer_store_id",
                                label : "Retail Store ID",
                                required : false,
                                type : "text",
                                disabled : true,
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'retailer_store_id')) ? cvs.json_options.configuration.retailer_store_id  : "",
                            },
                            {
                                name : "fulfillment_center_id",
                                label : "Fulfillment Center ID",
                                required : false,
                                type : "text",
                                disabled : true,
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'fulfillment_center_id')) ? cvs.json_options.configuration.fulfillment_center_id  : "",
                            },
                            {
                                name : "fulfillment_center_name",
                                label : "Fulfillment Center Name",
                                required : false,
                                type : "text",
                                disabled : true,
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'fulfillment_center_name')) ? cvs.json_options.configuration.fulfillment_center_name  : "",
                            },
                            {
                                name : "fulfillment_center_external_reference",
                                label : "Fulfillment Center External Reference",
                                required : false,
                                type : "text",
                                disabled : true,
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'fulfillment_center_external_reference')) ? cvs.json_options.configuration.fulfillment_center_external_reference  : "",
                            },
                            {
                                name : "sector_name",
                                label : "Sector Name",
                                required : false,
                                type : "text",
                                disabled : true,
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'sector_name')) ? cvs.json_options.configuration.sector_name  : "",
                            },
                            {
                                name : "sector_external_reference",
                                label : "Sector External Reference",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'sector_external_reference')) ? cvs.json_options.configuration.sector_external_reference  : "",
                            },
                            {
                                name : "promotion_price_label",
                                label : "Promotion Price Label",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'promotion_price_label')) ? cvs.json_options.configuration.promotion_price_label  : "",
                            },
                        ]
                    }
                ];
            }
        },
        mounted() {
            this.setItems();
        },
    };
</script>
